import { HubSpotForm } from "@/components/site/HubSpotForm";
import type { ReactNode } from "react";

export function HeroLeadForm({ headingLevel = "h3", layout = "card", sideContent, formFooter, lazy = false, eyebrow = "Free Growth Plan", heading = "Get your free law firm SEO plan.", intro = "Custom keyword & case forecast for your firm, delivered in 24 hours." }: { headingLevel?: "h2" | "h3"; layout?: "card" | "split"; sideContent?: ReactNode; formFooter?: ReactNode; lazy?: boolean; eyebrow?: string; heading?: string; intro?: string }) {
  const Heading = headingLevel;
  if (layout === "split") {
    return (
      <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-[minmax(0,5fr)_minmax(0,7fr)] lg:gap-12 xl:gap-16">
        <div className="hero-lead-form order-2 min-w-0 w-full lg:order-1 lg:max-w-[520px]">
          <div className="overflow-hidden rounded-lg bg-card p-2 shadow-lg sm:p-3 md:p-4">
            <HubSpotForm className="hs-form-on-light" lazy={lazy} />
          </div>
          <p className="mt-2 text-center text-[10px] text-primary-foreground/55 md:text-[11px]">
            🔒 100% confidential. No spam. Unsubscribe anytime.
          </p>
          {formFooter}
        </div>
        <div className="order-1 min-w-0 lg:order-2">
          <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-gold">
            <span className="h-px w-6 bg-gold" />{eyebrow}
          </div>
          <Heading className="mt-2 font-display text-xl font-semibold leading-tight text-primary-foreground md:text-2xl">
            {heading}
          </Heading>
          <p className="mt-1.5 text-xs text-primary-foreground/70 md:text-sm">
            {intro}
          </p>
          {sideContent}
        </div>
      </div>
    );
  }
  return (
    <div className="hero-lead-form overflow-hidden rounded-xl bg-white/[0.04] backdrop-blur border border-white/15 p-4 sm:p-5 md:p-6 shadow-2xl">
      <div className="flex items-center gap-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-[var(--gold)]">
        <span className="h-px w-6 bg-[var(--gold)]" />Free Growth Plan
      </div>
      <Heading className="mt-2 font-display text-xl md:text-2xl font-semibold text-primary-foreground leading-tight">
        Get your free law firm SEO plan.
      </Heading>
      <p className="mt-1.5 text-xs md:text-sm text-primary-foreground/70">
        Custom keyword & case forecast for your firm, delivered in 24 hours.
      </p>
      <div className="mt-4 overflow-hidden rounded-lg bg-white p-2 sm:p-3 md:p-4 shadow-lg">
        <HubSpotForm className="hs-form-on-light" />
      </div>
      <p className="mt-2 text-[10px] md:text-[11px] text-primary-foreground/55 text-center">
        🔒 100% confidential. No spam. Unsubscribe anytime.
      </p>
    </div>
  );
}
